import React from 'react';
import TypographyMaterial from '@material-ui/core/Typography';

const Typography = props => <TypographyMaterial {...props} />

export default Typography;
